var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThemeMode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8348 0.990234H9.16797V3.49048H10.8348V0.990234Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51847 3.33114L2.33984 4.50977L4.10778 6.27771L5.28641 5.09908L3.51847 3.33114Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4828 3.32972L14.7148 5.09766L15.8935 6.27628L17.6614 4.50834L16.4828 3.32972Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 16.826C13.2229 16.826 15.8348 14.2141 15.8348 10.9921C15.8348 7.77013 13.2229 5.1582 10.0009 5.1582C6.77892 5.1582 4.16699 7.77013 4.16699 10.9921C4.16699 14.2141 6.77892 16.826 10.0009 16.826Z",
    stroke: "white",
    strokeWidth: 0.784391
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50024 10.1582H0V11.825H2.50024V10.1582Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 10.1582H17.5V11.825H20.0002V10.1582Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10778 15.7028L2.33984 17.4707L3.51847 18.6493L5.28641 16.8814L4.10778 15.7028Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8915 15.7042L14.7129 16.8828L16.4808 18.6508L17.6595 17.4721L15.8915 15.7042Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8348 18.4902H9.16797V20.9905H10.8348V18.4902Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeMode);
export default __webpack_public_path__ + "static/media/themeMode.7d46006c5cd636d193eeca89516adf64.svg";
export { ForwardRef as ReactComponent };